import { SearchWorkersContainer } from './SearchWorkersContainer';

const name = 'SearchWorkersContainer';

export { name, SearchWorkersContainer };
